import React from "react"
// import { Button, Modal } from "react-bootstrap";
// import { getClass } from "../../Helper";
import axios from "axios"
// import uuid from "uuid/v4";
import { notify } from "react-notify-toast"
// import { useArray, useForceUpdate } from "../../Hook";
import "./model_style.css"
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import CancelButton from "../../Components/Buttons/CancelButton"
import Modal from "../../Components/Modal/Modal"
import { API } from "../../API"
import moment from 'moment'
import FormField from "../../Components/FormField/FormField";
import AvatarEditor from "react-avatar-editor";
import { handleLogErrorToSlack } from "../../Helper"

class UploadAvatars extends React.Component {
  constructor(props) {
    super(props)
    const src = ""
    this.state = {
      preview: null,
      src,
      file: null,
      Name: null,
      newFileName: "",
      oldFileName: null,
      email_notified: false,
      rotate: 0,
      imgSrc: null,
      fileName: null,
      editor: null,
      fileType: null,
      fileSize: "",
      url: "",
      scaleValue: 1,
      showPicker: false,
      cropReady: false,
    }

    this.onCrop = this.onCrop.bind(this)
    this.onClose = this.onClose.bind(this)
    this.UploadAvatarsNow = this.UploadAvatarsNow.bind(this)
    this.onCropDefault = this.onCropDefault.bind(this)
    this.urltoFile = this.urltoFile.bind(this)
    this.onBeforeFileLoad = this.onBeforeFileLoad.bind(this)
  }

  urltoFile = (url, filename, mimeType) => {
    mimeType = mimeType || (url.match(/^data:([^;]+);/) || "")[1]
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer()
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType })
      })
  }

  onClose = () => {
    this.setState({ preview: null })
  }

  onCrop = () => {
    const { editor } = this.state;
    if (editor !== null) {
      const url = editor.getImage().toDataURL();
      this.setState({ userProfilePic: url });
      // console.log("userProfilePic： ",url);
      this.urltoFile(url, this.state.Name).then((file) => {
        // console.log("file: ", file, " fileSize: ", file.size);
        this.setState({ fileSize: file.size });
        this.setState({ file: file });
      });
    }
    this.setState({ cropReady: true });
  };

  onScaleChange = (scaleChangeEvent) => {
    const scaleValue = parseFloat(scaleChangeEvent.target.value) / 50;
    // console.log("scaleValue: ",scaleValue)
    this.setState({ scaleValue });
  };

  setEditorRef = (editor) => {
    this.setState({ editor });
  };

  onRotate = () => {
    let newRotation = parseFloat(this.state.rotate) + 90;
    if(newRotation >= 360){
      newRotation =- 360;
    }
    // console.log('newRotation', newRotation)
    this.setState({
      rotate: newRotation,
    })
  }

  onBeforeFileLoad = (elem) => {
    if (elem.target.files[0].type === "application/pdf") {
      elem.target.value = ""
      notify.show("Invalid file format, please select file type other than pdf")
    }
  }

  UploadAvatarsNow = () => {
    const file = this.state.file
    const today = moment()
    const time = today.format('HH:mm:ss')
    const day = today.format('_yy_MM_DD_')

    if (file) {
      const [fileName, fileType] = file.name.split(".")
      this.setState({ oldFileName: fileName })
      // const updateUser = this.props.updateUser;

      API.uploadFileToS3({
        fileName: `profilePic${day}${time}`,
        fileType: fileType,
        _id: this.props.user._id,
      })
        .then((response) => {
          const returnData = response.data.data.returnData
          const signedRequest = returnData.signedRequest
          const url = returnData.url
          // Put the fileType in the headers for the upload
          const options = {
            headers: {
              "Content-Type": fileType,
            },
          }
          axios
            .put(signedRequest, file, options)
            .then((response2) => {
              // save the img_url into user and change the ui
              const newUser = Object.assign({}, this.props.user)
              newUser.img_url = url
              newUser.profile_photo_name = this.state.oldFileName
              // updateUser(newUser)
              this.props.setUser(newUser)
              // window.localStorage.setItem("user", JSON.stringify(newUser));
              this.props.updateUser(newUser)
              API.updateUserInfo({
                img_url: url,
              })
                .then((res) => {
                  this.forceUpdate()
                  this.props.showPopup(false)
                  notify.show("Profile picture added successfully")

                  // Email notification

                  if (this.state.email_notified === false) {
                    API.sendTeacherProfileProgressEmail({
                      _id: this.props.user._id,
                        to: this.props.user.email,
                        first_name: this.props.user.first_name,
                        etype: "AVATAR_CONF",
                    })
                      .then((result) => {
                        // console.log('result:', result)
                        this.setState({
                          email_notified: true,
                        })
                      })
                      .catch((err) => {
                        console.log('err:', err)
                      })
                  }
                })
                .catch((err) => {
                  console.log(err)
                })
            })
            .catch((error) => {
              handleLogErrorToSlack(error, true)
              console.log(error, "a")

              alert("ERROR " + JSON.stringify(error))
            })
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    } else {
      // show uploading error
      console.log("upload error")
    }
  }

  onCropDefault = (preview) => {
    this.setState({ defaultPreview: preview })
  }

  onFileLoad = (e) => {
    this.setState({ file: e })
    this.setState({ Name: e.name })
  }

  onhide = () => {
    this.props.showPopup(false)
  }

  uploadDocument = (id) => {
    // console.log("upload doc", id);
    this.setState({ showPicker: true });
    document.getElementById(id).click();
    // console.log("ADRIENNE", this.state);
  };

  fileSelectHandler = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        this.setState({
          imgSrc: reader.result,
        });
      }
    };
    reader.readAsDataURL(file);
    // console.log("1: ",this.state.imgSrc);
    // console.log("2 ",file.name)
    this.setState({ file: file });
    this.setState({ Name: file.name });
  };

  render() {
    return (
      <Modal
        show={true}
        className="avatar-upload-modal"
        header="Upload a Professional Photo"
        onClose={this.onhide}
      >
        <div className="row upload-avatar-form-box">
          <div className="upload-avatar-form">
            <FormField
              label={"Upload Avatar"}
              // name="filePicker"
              disabled
              sideButton={{
                onClick: () =>
                  this.uploadDocument("avatar", console.log("formfield button1")),
                id: "Select_Button",
                label: this.state.fileName ? "Uploaded" : "Select",
                small: true,
                disabled: this.state.fileName,
              }}
            />
            <input
              type="file"
              id="avatar"
              name="filepicker"
              onChange={this.fileSelectHandler}
              hidden={this.state.showPicker}
              ref={(ref) => {
                this.uploadInput = ref;
              }}
              style={{ display: "none" }}
              accept="image/*"
            />

            <div className="upload-logo-editor">
              <div className="upload-logo-column">
                <label> Crop Editor </label>
                <AvatarEditor
                  image={this.state.imgSrc}
                  border={0.5}
                  scale={this.state.scaleValue}
                  rotate={this.state.rotate}
                  width={200}
                  height={200}
                  borderRadius={180}
                  onFileLoad={this.onFileLoad}
                  ref={this.setEditorRef}
                  className="cropCanvas"
                />
                <input
                  type={"range"}
                  onChange={this.onScaleChange}
                  // value={this.state.scaleValue}
                />
              </div>

              <div className="upload-logo-column">
                <label> Crop Preview </label>
                <img
                  style={{
                    borderRadius: '50%',
                    border: "1px solid black"
                  }}
                  width={200}
                  height={200}
                  src={this.state.userProfilePic}
                />
              </div>
            </div>

            <div className="row mx-2">
              <CancelButton className='col' onClick={(e) => this.onRotate()}>Rotate</CancelButton>
              <CancelButton className='col' onClick={(e) => this.onCrop()}>Crop</CancelButton>
            </div>

            <input
              type="file"
              id="avatar"
              name="filepicker"
              onChange={this.fileSelectHandler}
              hidden={this.state.showPicker}
              ref={(ref) => {
                this.uploadInput = ref;
                // console.log("ADRIENNE Step 2", this.state);
              }}
              style={{ display: "none" }}
              accept="image/*"
            />
          </div>
        </div>
        <div className="row upload-button-box">
          <div className="col-md-6 mb-2 mb-md-0">
            <CancelButton onClick={this.onhide}>Cancel</CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton
              disabled={!this.state.cropReady}
              onClick={this.UploadAvatarsNow}
            >
              Update
            </ConfirmButton>
          </div>
        </div>
      </Modal>
    )
  }
}

export default UploadAvatars
